window.RemoveMembersForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            removeMembersForm: '#remove-members-form',
            messages: {
                invalidCheckboxError: '#remove-members-form-error'
            },
            checkBox: {
                confirmCheck: 'input[name="member-checkbox"]'
            },
            button: {
                continue: '#remove-members-form-continue'
            }
        },
        css: {
            invalidCheckbox: 'vds-checkbox--invalid',
            confirmCheckContainer: '#remove-members-form-check-container'
        },
        urls: {
            removalReasonPageUrl: '/my-health-insurance/manage-my-plan/manage-members/remove-members/removal-reason',
            errorPageUrl: '/error/error-page',
            sendRemoveMembersFormDetails: '/api/sitecore/RemoveMembers/SendRemoveMembersFormDetails'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
                $(self.elements.messages.invalidCheckboxError).hide();
                $(self.css.confirmCheckContainer).removeClass(self.css.invalidCheckbox);
            },
            bindings: function () {
                $(self.elements.checkBox.confirmCheck).on('change', self.func.validateCheckbox);
                $(self.elements.removeMembersForm).on('submit', self.func.handleContinue);
            },
            handleContinue: function (event) {
                event.preventDefault();
                if (self.func.handleCheckbox()) {
                    let members = new Array();
                    $("input[name='member-checkbox']:checked").each(function () {
                        let obj = {
                            DependantMembershipNo: $(this).data('entity'),
                            DependantFullName: $(this).data('members'),
                            IsSelected: 'true'
                        };
                        members.push(obj);
                    });
                    self.func.submitFormData(members);
                }
            },
            handleCheckbox: function () {
                if ($(self.elements.checkBox.confirmCheck).is(':checked')) {
                    $(self.elements.messages.invalidCheckboxError).hide();
                    $(self.css.confirmCheckContainer).removeClass(self.css.invalidCheckbox);
                    return true;
                } else {
                    $(self.elements.messages.invalidCheckboxError).show();
                    $(self.css.confirmCheckContainer).addClass(self.css.invalidCheckbox);
                    return false;
                }
            },
            validateCheckbox: function () {
                if ($(self.elements.checkBox.confirmCheck).is(':checked')) {
                    $(self.elements.messages.invalidCheckboxError).hide();
                    $(self.css.ConfirmCheckContainer).removeClass(self.css.InvalidCheckbox);
                }
            },
            submitFormData: function (members) {
                $.ajax({
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    url: self.urls.sendRemoveMembersFormDetails,
                    data: JSON.stringify({ 'members': members }),
                    success: function (response) {
                        if (response.success) {
                            window.location.href = self.urls.removalReasonPageUrl;
                        }
                        else {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    },
                    error: function () {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('removeMembers' === $('#remove-members-form').data('feature')) {
        window.RemoveMembersForm.Init();
    }
});
